import { Link } from "react-router";

import { CheckCircleOutline } from "@mui/icons-material";
import { Alert } from "@mui/material";

import { useAuthUser } from "@features/auth/AuthUserContext";
import { distUrl } from "@features/navigation/helpers";
import { Button } from "@features/ui";
import { Realm } from "@models/Realm";

import { useCurrentOrderSet } from "../orderSet/data/CurrentOrderSetContext";

const SetIsWorkInProgressButton = ({
  toggleWorkInProgress,
  isUpdateLoading,
}) => {
  const { orderSet } = useCurrentOrderSet();
  const { realm } = useAuthUser();

  const programListUrl =
    realm === Realm.Distributor
      ? distUrl("/place-order/programs")
      : `/programs/${orderSet.orderCalendarMonth?.orderWindowType}`;

  if (orderSet.isWorkComplete) {
    return (
      <div>
        <Alert
          severity="success"
          title="Complete"
          className="-m-2 mb-2 text-sm rounded-lg bg-lime-100 text-lime-800"
        >
          You've marked this order set as complete. You can continue to make
          changes to it until the order-window closes.
        </Alert>
        <div className="flex gap-2 mt-3">
          <Button
            className="whitespace-nowrap"
            variant="contained"
            color="primary"
            fullWidth
            component={Link}
            to={programListUrl}
          >
            Back to Programs
          </Button>
          <Button
            variant="text"
            color="secondary"
            fullWidth
            onClick={toggleWorkInProgress}
          >
            Mark In-Progress
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Button
      variant="contained"
      fullWidth
      onClick={toggleWorkInProgress}
      loading={isUpdateLoading}
      endIcon={<CheckCircleOutline />}
    >
      Mark as Complete
    </Button>
  );
};

export default SetIsWorkInProgressButton;
